import type { Maybe } from '@vrplatform/utils';

export const getOwnerPortalColor = (color: Maybe<string>) => {
  if (!color) return undefined;
  if (color.includes('portal.')) return color;
  else return `portal.${color}`;
};
